module.exports = __webpack_public_path__ + "workspace/static/img/downloadSignatureThree.192ff70.png";